import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Messages from "../pages/Messages";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const messagesRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/messages"
      element={
        <>
          <PageTitle title="Messages | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <Messages />
        </>
      }
    />
  </Route>
);

export default messagesRoutes;
